export const initHeaderSearch = () => {
  const header = document.getElementById("header") as HTMLDivElement;

  if (!header) {
    return;
  }

  const headerSearchExpandButton = header.querySelector(
    ".search-expand-button",
  ) as HTMLButtonElement;
  const headerSearchBar = header.querySelector(".search-bar") as HTMLDivElement;
  const searchBarMask = document.getElementById("search-bar-mask") as HTMLDivElement;

  if (!headerSearchExpandButton || !headerSearchBar || !searchBarMask) {
    return;
  }

  headerSearchExpandButton.addEventListener("click", (e) => {
    e.preventDefault();

    headerSearchExpandButton.classList.remove("active");
    headerSearchBar.classList.add("active");
    searchBarMask.classList.remove("d-none");

    focusOnInput(headerSearchBar);
  });

  searchBarMask.addEventListener("click", () => {
    headerSearchExpandButton.classList.add("active");
    headerSearchBar.classList.remove("active");
    searchBarMask.classList.add("d-none");
  });

  // We have multiples searchbars on the homepage
  const searchBars: NodeListOf<HTMLDivElement> = document.querySelectorAll(".search-bar");

  searchBars.forEach((searchBar) => {
    const searchTabs: NodeListOf<HTMLDivElement> = searchBar.querySelectorAll(".search-tabs .tab");
    const autocomplete = searchBar.querySelector(".autocomplete") as HTMLDivElement;
    const labelBabysitterSearch = autocomplete.querySelector(
      ".label-babysitter-search",
    ) as HTMLSpanElement;
    const labelNannySearch = autocomplete.querySelector(".label-nanny-search") as HTMLSpanElement;
    const labelChildminderSearch = autocomplete.querySelector(
      ".label-childminder-search",
    ) as HTMLSpanElement;
    const labelParentSearch = autocomplete.querySelector(".label-parent-search") as HTMLSpanElement;

    searchTabs.forEach((searchTab) => {
      searchTab.addEventListener("click", (e) => {
        e.preventDefault();
        resetTabs(searchTabs);
        searchTab.classList.add("active");

        autocomplete.dataset.autocompleteUrlValue = searchTab.dataset.searchUrl;

        labelBabysitterSearch.classList.add("d-none");
        labelNannySearch.classList.add("d-none");
        labelChildminderSearch.classList.add("d-none");
        labelParentSearch.classList.add("d-none");

        if (searchTab.dataset.searchType === "babysitter") {
          labelBabysitterSearch.classList.remove("d-none");
        } else if (searchTab.dataset.searchType === "nanny") {
          labelNannySearch.classList.remove("d-none");
        } else if (searchTab.dataset.searchType === "childminder") {
          labelChildminderSearch.classList.remove("d-none");
        } else {
          labelParentSearch.classList.remove("d-none");
        }

        /* Put attention to this action by focussing on input */
        focusOnInput(searchBar);
      });
    });
  });

  function resetTabs(searchTabs: NodeListOf<HTMLDivElement>) {
    searchTabs.forEach((searchTab) => {
      searchTab.classList.remove("active");
    });
  }

  function focusOnInput(searchBar: HTMLDivElement) {
    const searchBarInput = searchBar.querySelector("input") as HTMLInputElement;

    // Wait 300ms until the element becomes visible and click+focus
    setTimeout(() => {
      searchBarInput.click();
      searchBarInput.focus();
    }, 300);

    // const header = document.getElementById("header");
    //
    // const searchExpandable = header.querySelector(".search-expandable");
    // /**
    //  *  Fix for opening keyboard when focus on element in iOS 13:
    //  *  - Create temp element
    //  *  - Focus and click on this element: it will open the keyboard
    //  *  - Last focus+click on desired element
    //  *
    //  *  https://stackoverflow.com/questions/54424729/ios-show-keyboard-on-input-focus
    //  **/
    // let tempElement = document.createElement("input");
    // tempElement.style.position = "absolute";
    // tempElement.style.top = searchExpandable.offsetTop + 215 + "px";
    // tempElement.style.left = searchExpandable.offsetLeft + "px";
    // tempElement.style.height = 0;
    // tempElement.style.opacity = 0;
    //
    // searchExpandable.appendChild(tempElement);
    // tempElement.focus();
    //
    // setTimeout(function () {
    //     searchBarInput.focus();
    //     searchBarInput.click();
    //
    //     searchExpandable.removeChild(tempElement);
    // }, 300);
  }
};
